var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 368,
    viewBox: "0 0 480 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6033_37455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 26,
    width: 463,
    height: 317
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 463,
    height: 317,
    fill: "#31C1BB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6033_37455)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.034 325.298C114.007 325.298 11.0315 265.932 11.0315 192.7C11.0315 119.468 114.007 60.1016 241.034 60.1016C368.061 60.1016 471.037 119.468 471.037 192.7C471.037 265.932 368.061 325.298 241.034 325.298Z",
    fill: "#31C1BB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6033_37455)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.863 260.515H340.146L282.336 224.551H367.101L487.709 299.576H402.945L347.804 265.271H324.873L337.211 268.92L353.695 273.609L348.522 276.839H346.736L308.018 263.767L305.514 264.519L324.77 291.68L320.069 294.6H318.18L315.347 287.456L304.569 270.734L302.66 260.515L308.1 261.378L305.863 260.515Z",
    fill: "#8D8D8D",
    fillOpacity: 0.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.956 224.27L273.981 228.362L296.919 258.538V254.446L273.956 224.27Z",
    fill: "#EEE8DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.199 244.43L239.224 248.522L292.247 262.304V258.212L239.199 244.43Z",
    fill: "#E4DFD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292.247 258.215V262.307L302.541 268.332V264.24L292.247 258.215Z",
    fill: "#EEE8DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.038 261.527V265.619L360.836 279.076L360.811 274.984L309.038 261.527Z",
    fill: "#E4DFD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.811 274.982L360.836 279.074L366.758 275.635V271.543L360.811 274.982Z",
    fill: "#CBC7BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.054 295.142L326.079 299.235L332.001 295.795L331.976 291.703L326.054 295.142Z",
    fill: "#CBC7BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.541 264.238V268.33L326.079 299.234L326.054 295.142L302.541 264.238Z",
    fill: "#EEE8DE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.247 258.213L302.541 264.238L326.054 295.142L331.976 291.703L309.038 261.527L360.811 274.983L366.758 271.544L313.71 257.761L303.416 251.736L279.903 220.832L273.956 224.271L296.919 254.447L245.121 240.991L239.199 244.431L292.247 258.213Z",
    fill: "#F7F5ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M313.711 257.76L324.48 260.547H302.941L304.665 252.488L313.711 257.76Z",
    fill: "#CBC7BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M299.618 183.753C301.442 184.807 304.416 184.807 306.265 183.753C308.089 182.699 308.089 180.966 306.265 179.912C304.441 178.857 301.467 178.857 299.618 179.912C297.794 180.966 297.794 182.699 299.618 183.753Z",
    fill: "#CBC7BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M298.244 181.793V257.811C298.244 258.513 298.693 259.216 299.618 259.769C301.442 260.823 304.415 260.823 306.264 259.769C307.164 259.242 307.639 258.564 307.639 257.861V181.843C307.639 182.521 307.164 183.224 306.264 183.751C304.44 184.806 301.467 184.806 299.618 183.751C298.693 183.224 298.244 182.496 298.244 181.793Z",
    fill: "url(#paint0_linear_6033_37455)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M371.73 252.915L375.953 250.48V140.973L371.73 143.433V252.915Z",
    fill: "#CBC7BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.534 165.225L371.73 252.916V143.434L220.534 55.7422V165.225Z",
    fill: "#EEE8DE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M369.232 144.89L223.033 60.0859V163.769L369.232 248.573V144.89Z",
    fill: "#F7F5ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.73 143.433L375.953 140.973L224.757 53.2812L220.534 55.7415L371.73 143.433Z",
    fill: "#F7F5ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M235.201 161.911C235.301 161.785 235.451 161.71 235.626 161.735L239.024 162.137C239.224 162.137 239.399 162.313 239.424 162.514C239.424 162.639 239.424 162.739 239.374 162.84C239.324 162.915 239.274 162.965 239.199 163.016L238.5 163.417L353.64 230.221C353.565 230.548 353.515 230.874 353.44 231.201L237.55 163.97L236.476 164.597C236.476 164.597 236.201 164.673 236.076 164.622C235.951 164.572 235.851 164.472 235.801 164.321L235.126 162.363C235.076 162.212 235.126 162.037 235.201 161.911Z",
    fill: "#CBC7BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.492 126.061L258.039 126.312C259.014 126.362 260.163 126.964 261.188 127.994L272.482 139.241C273.182 139.944 273.956 140.471 274.706 140.722L284.701 144.237C285.6 144.538 286.525 145.241 287.324 146.145L300.217 160.956C301.017 161.885 301.967 162.563 302.866 162.864L315.585 167.233C316.384 167.509 317.209 168.061 317.933 168.839L327.703 178.957C328.628 179.911 329.652 180.538 330.602 180.689L340.871 182.496C342.021 182.697 343.345 183.626 344.37 184.932L353.665 196.882V230.648L237.6 163.316V119.207L244.147 120.387C245.021 120.538 245.971 121.09 246.845 121.943L249.444 124.454C250.443 125.408 251.568 126.01 252.492 126.036V126.061Z",
    fill: "#128DE9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M240.699 138.313L245.921 143.886C246.895 144.915 248.02 145.593 249.019 145.744L265.236 147.928C266.06 148.028 267.01 148.53 267.859 149.334L278.004 158.547C278.679 159.175 279.403 159.602 280.103 159.828L292.971 163.844C293.921 164.146 294.92 164.874 295.77 165.853L308.688 180.891C309.388 181.719 310.237 182.372 311.037 182.723L321.057 187.167C321.756 187.468 322.481 187.995 323.131 188.673L334.4 200.548C335.249 201.452 336.224 202.079 337.123 202.28L346.643 204.665V234.715L230.579 167.384V135.074L237.775 136.455C238.725 136.631 239.799 137.309 240.699 138.288V138.313Z",
    fill: "#31C1BB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M232.378 148.533L238.1 153.704C238.974 154.482 239.899 154.985 240.723 155.085L246.446 155.838C247.32 155.964 248.32 156.491 249.219 157.344L257.015 164.75C257.965 165.654 258.989 166.206 259.889 166.282L269.284 167.135C270.358 167.236 271.607 167.989 272.657 169.169L289.873 188.6C290.897 189.755 292.147 190.533 293.221 190.633L300.118 191.362C301.117 191.462 302.291 192.14 303.291 193.219L315.709 206.45C316.734 207.554 317.958 208.257 318.983 208.307L326.279 208.809C327.153 208.86 328.178 209.387 329.102 210.24L338.573 218.876V239.362L222.508 172.031V145.219L230.079 147.227C230.804 147.428 231.578 147.88 232.303 148.533H232.378Z",
    fill: "#FF7053"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M224.932 164.17L230.654 169.342C231.528 170.145 232.503 170.647 233.327 170.723L238.75 171.325C239.749 171.426 240.898 172.104 241.898 173.183L246.57 178.154C247.695 179.359 249.044 180.062 250.119 180.012L261.937 179.484C263.087 179.434 264.511 180.238 265.685 181.568L279.178 196.982C280.253 198.213 281.577 198.991 282.677 199.066L292.746 199.644C293.746 199.694 294.92 200.347 295.945 201.401L308.513 214.33C309.438 215.284 310.487 215.912 311.412 216.062L318.983 217.317C319.807 217.443 320.707 217.945 321.531 218.698L331.151 227.46V243.678L215.087 176.346V160.781L222.683 162.865C223.408 163.066 224.157 163.518 224.882 164.145L224.932 164.17Z",
    fill: "#EEE8DE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M217.935 174.513L221.933 177.4C223.158 178.279 224.382 178.931 225.581 179.333L229.779 180.764C231.303 181.291 232.903 182.22 234.427 183.475L237.925 186.362C239.399 187.593 240.948 188.496 242.448 189.024L253.517 192.915C254.866 193.392 256.29 194.195 257.665 195.275L270.258 205.166C271.882 206.446 273.556 207.325 275.131 207.752L282.852 209.836C284.551 210.287 286.35 211.267 288.074 212.697L299.268 221.911C300.917 223.267 302.641 224.221 304.265 224.698L308.538 225.953C310.612 226.555 312.836 227.961 314.86 229.945L323.006 237.928L323.056 248.472L206.991 181.141L206.941 170.848L213.388 172.329C214.862 172.655 216.436 173.433 217.985 174.538L217.935 174.513Z",
    fill: "#F7F5ED"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M317.758 251.106L353.115 230.596V144.762C353.115 144.511 353.315 144.285 353.59 144.285C353.865 144.285 354.064 144.486 354.064 144.762V230.872C354.064 231.048 353.965 231.198 353.84 231.274L318.258 251.91C318.258 251.91 318.108 251.985 318.033 251.985C317.883 251.985 317.708 251.91 317.633 251.759C317.509 251.533 317.583 251.232 317.808 251.106H317.758Z",
    fill: "#CBC7BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M351.916 144.211L353.265 142.63C353.265 142.63 353.54 142.454 353.69 142.479C353.84 142.479 353.99 142.605 354.039 142.755L355.389 145.918C355.464 146.119 355.414 146.32 355.264 146.471C355.164 146.546 355.064 146.596 354.939 146.596C354.864 146.596 354.789 146.596 354.714 146.521L351.991 144.939C351.991 144.939 351.791 144.738 351.766 144.613C351.766 144.462 351.766 144.337 351.866 144.211H351.916Z",
    fill: "#CBC7BC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M315.959 252.413L316.359 250.354C316.384 250.204 316.509 250.053 316.659 250.003C316.809 249.952 316.984 249.978 317.109 250.053L319.857 252.111C320.032 252.237 320.082 252.438 320.032 252.639C319.982 252.764 319.907 252.84 319.832 252.89C319.757 252.94 319.682 252.965 319.607 252.965H316.459C316.309 252.965 316.184 252.89 316.084 252.789C315.984 252.689 315.959 252.538 315.984 252.388L315.959 252.413Z",
    fill: "#CBC7BC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M337.923 143.336L343.645 146.649V145.419L337.923 142.105V143.336Z",
    fill: "#D6D1C7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332.576 140.222L336.274 142.381V141.151L332.576 138.992V140.222Z",
    fill: "#D6D1C7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 134.8L330.927 139.269V138.039L323.206 133.57V134.8Z",
    fill: "#D6D1C7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M312.761 128.747L321.556 133.844V132.614L312.761 127.492V128.747Z",
    fill: "#D6D1C7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M311.112 126.542V127.772L302.316 122.675V121.445L311.112 126.542Z",
    fill: "#D6D1C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M296.994 119.586L300.667 121.72V120.489L296.994 118.355V119.586Z",
    fill: "#D6D1C7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 115.494L295.345 118.632V117.401L289.923 114.238V115.494Z",
    fill: "#D6D1C7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M334.775 144.84L343.645 149.986V148.756L334.775 143.609V144.84Z",
    fill: "#D6D1C7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 141.751L333.125 143.885V142.655L329.402 140.496V141.751Z",
    fill: "#D6D1C7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 138.161L327.753 140.772V139.542L323.206 136.906V138.161Z",
    fill: "#D6D1C7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M316.534 134.273L321.556 137.185V135.955L316.534 133.043V134.273Z",
    fill: "#D6D1C7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M314.885 132.087V133.317L306.764 128.597V127.367L314.885 132.087Z",
    fill: "#D6D1C7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M299.643 124.48L305.115 127.643V126.413L299.643 123.25V124.48Z",
    fill: "#D6D1C7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 118.832L297.994 123.526V122.296L289.923 117.602V118.832Z",
    fill: "#D6D1C7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M337.923 150.039L343.645 153.353V152.122L337.923 148.809V150.039Z",
    fill: "#D6D1C7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M332.576 146.925L336.274 149.084V147.854L332.576 145.695V146.925Z",
    fill: "#D6D1C7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 141.504L330.927 145.972V144.742L323.206 140.273V141.504Z",
    fill: "#D6D1C7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M312.761 135.425L321.556 140.547V139.317L312.761 134.195V135.425Z",
    fill: "#D6D1C7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M311.112 133.241V134.471L302.316 129.375V128.145L311.112 133.241Z",
    fill: "#D6D1C7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M296.994 126.289L300.667 128.423V127.193L296.994 125.059V126.289Z",
    fill: "#D6D1C7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 122.172L295.345 125.335V124.105L289.923 120.941V122.172Z",
    fill: "#D6D1C7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M334.775 151.543L343.645 156.689V155.459L334.775 150.312V151.543Z",
    fill: "#D6D1C7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 148.429L333.125 150.588V149.358L329.402 147.199V148.429Z",
    fill: "#D6D1C7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 144.84L327.753 147.476V146.245L323.206 143.609V144.84Z",
    fill: "#D6D1C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M316.534 140.976L321.556 143.888V142.658L316.534 139.746V140.976Z",
    fill: "#D6D1C7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M314.885 138.765V140.02L306.764 135.3V134.07L314.885 138.765Z",
    fill: "#D6D1C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M299.643 131.183L305.115 134.346V133.116L299.643 129.953V131.183Z",
    fill: "#D6D1C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 125.535L297.994 130.229V128.999L289.923 124.305V125.535Z",
    fill: "#D6D1C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M337.923 156.742L343.645 160.056V158.8L337.923 155.512V156.742Z",
    fill: "#D6D1C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M332.576 153.629L336.274 155.788V154.532L332.576 152.398V153.629Z",
    fill: "#D6D1C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 148.207L330.927 152.675V151.445L323.206 146.977V148.207Z",
    fill: "#D6D1C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M312.761 142.129L321.556 147.25V145.995L312.761 140.898V142.129Z",
    fill: "#D6D1C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M311.112 139.944V141.174L302.316 136.078V134.848L311.112 139.944Z",
    fill: "#D6D1C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M296.994 132.992L300.667 135.126V133.871L296.994 131.762V132.992Z",
    fill: "#D6D1C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 128.875L295.345 132.038V130.808L289.923 127.645V128.875Z",
    fill: "#D6D1C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M334.775 158.246L343.645 163.392V162.162L334.775 157.016V158.246Z",
    fill: "#D6D1C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 155.132L333.125 157.291V156.061L329.402 153.902V155.132Z",
    fill: "#D6D1C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M323.206 151.543L327.753 154.179V152.949L323.206 150.312V151.543Z",
    fill: "#D6D1C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M316.534 147.677L321.556 150.589V149.359L316.534 146.422V147.677Z",
    fill: "#D6D1C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M314.885 145.468V146.698L306.764 142.004V140.773L314.885 145.468Z",
    fill: "#D6D1C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M299.643 137.886L305.115 141.05V139.819L299.643 136.656V137.886Z",
    fill: "#D6D1C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M289.923 132.238L297.994 136.933V135.677L289.923 131.008V132.238Z",
    fill: "#D6D1C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M265.436 103.843C268.034 101.76 272.407 102.864 276.605 106.68L273.531 114.438L263.537 108.638C263.537 106.429 264.136 104.898 265.436 103.843Z",
    fill: "url(#paint1_linear_6033_37455)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M273.506 114.439L283.501 120.239C283.501 115.795 280.803 110.498 276.605 106.707L273.531 114.464L273.506 114.439Z",
    fill: "url(#paint2_linear_6033_37455)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M273.506 114.438L279.378 125.961C282.052 125.559 283.501 123.551 283.501 120.237L273.506 114.438Z",
    fill: "#31C1BB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M270.433 122.168C266.235 118.377 263.537 113.055 263.537 108.637L273.531 114.436L279.403 125.959C276.73 126.361 273.606 125.03 270.458 122.193L270.433 122.168Z",
    fill: "#EEE8DE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M247.245 99.2004L252.043 93.125C253.992 95.3091 255.366 97.5686 256.315 100.129C257.74 103.97 257.665 107.134 256.065 109.142L247.245 99.2004Z",
    fill: "url(#paint3_linear_6033_37455)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M247.245 99.1998L252.043 93.1244C247.17 87.6515 241.073 85.9193 238.425 89.2583C235.776 92.6223 237.575 99.7772 242.448 105.25C244.397 107.434 246.346 108.94 248.544 109.92L247.245 99.1747V99.1998Z",
    fill: "#31C1BB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M247.245 99.2009L248.544 109.946C251.843 111.427 254.466 111.151 256.065 109.117L247.245 99.1758V99.2009Z",
    fill: "#EEE8DE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.444 130.781C200.444 130.781 200.669 130.756 200.744 130.706L227.855 114.965C228.155 114.79 228.255 114.413 228.08 114.112C227.905 113.811 227.53 113.71 227.231 113.886L201.044 129.074V96.187C201.044 95.961 200.919 95.7602 200.744 95.6346L169.611 77.5591C169.311 77.3834 168.936 77.4838 168.761 77.7851C168.586 78.0863 168.686 78.4629 168.986 78.6386L199.82 96.5133V130.129C199.82 130.355 199.945 130.556 200.12 130.681C200.22 130.731 200.32 130.756 200.419 130.756L200.444 130.781Z",
    fill: "#E6E1D7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M397.967 206.623C397.967 206.623 398.192 206.598 398.266 206.548C398.466 206.422 398.566 206.221 398.566 205.995V162.238L441.694 187.242C441.994 187.418 442.369 187.317 442.543 187.016C442.718 186.715 442.618 186.338 442.319 186.163L398.266 160.606C398.067 160.48 397.842 160.48 397.642 160.606C397.442 160.706 397.342 160.932 397.342 161.158V204.916L360.461 183.527L365.733 180.464C366.033 180.288 366.133 179.912 365.958 179.61C365.783 179.309 365.409 179.209 365.109 179.384L358.887 182.999C358.687 183.125 358.587 183.326 358.587 183.552C358.587 183.778 358.712 183.979 358.887 184.104L397.642 206.573C397.642 206.573 397.842 206.648 397.942 206.648L397.967 206.623Z",
    fill: "#E6E1D7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M439.12 164.145L442.019 165.827V167.082L439.12 165.4V164.145Z",
    fill: "#E6E1D7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M433.723 161.008L437.471 163.192V164.422L433.723 162.263V161.008Z",
    fill: "#E6E1D7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M421.754 155.308V154.078L432.049 160.053V161.283L421.754 155.308Z",
    fill: "#E6E1D7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M435.947 165.676L442.019 169.216V170.446L435.947 166.931V165.676Z",
    fill: "#E6E1D7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M434.273 165.953L430.525 163.794V162.539L434.273 164.723V165.953Z",
    fill: "#E6E1D7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M425.677 160.982V159.727L428.851 161.584V162.814L425.677 160.982Z",
    fill: "#E6E1D7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M424.003 160.001L421.879 158.771V157.516L424.003 158.746V160.001Z",
    fill: "#E6E1D7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M439.12 170.922L442.019 172.579V173.834L439.12 172.152V170.922Z",
    fill: "#E6E1D7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M437.471 171.199L433.723 169.015V167.785L437.471 169.944V171.199Z",
    fill: "#E6E1D7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M432.049 168.061L424.003 163.392V162.137L432.049 166.806V168.061Z",
    fill: "#E6E1D7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M435.947 172.453L442.019 175.968V177.223L435.947 173.683V172.453Z",
    fill: "#E6E1D7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M430.525 169.316L434.273 171.475V172.731L430.525 170.547V169.316Z",
    fill: "#E6E1D7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M428.851 168.338V169.593L425.677 167.736V166.48L428.851 168.338Z",
    fill: "#E6E1D7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M439.12 177.676L442.019 179.358V180.613L439.12 178.931V177.676Z",
    fill: "#E6E1D7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M437.471 177.978L433.723 175.794V174.539L437.471 176.723V177.978Z",
    fill: "#E6E1D7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M424.703 170.572V169.316L432.049 173.584V174.814L424.703 170.572Z",
    fill: "#E6E1D7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 72.9609L200.245 74.643V75.8731L197.371 74.2162V72.9609Z",
    fill: "#E6E1D7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M191.949 69.8242L195.697 71.9832V73.2385L191.949 71.0544V69.8242Z",
    fill: "#E6E1D7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M180.105 64.2006V62.9453L190.275 68.845V70.1002L180.105 64.2006Z",
    fill: "#E6E1D7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M176.307 60.7617L178.431 61.9919V63.222L176.307 61.9919V60.7617Z",
    fill: "#E6E1D7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M194.173 74.4922L200.245 78.0069V79.2621L194.173 75.7474V74.4922Z",
    fill: "#E6E1D7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M192.499 74.7697L188.751 72.5856V71.3555L192.499 73.5145V74.7697Z",
    fill: "#E6E1D7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M183.903 69.7731V68.543L187.076 70.3756V71.6309L183.903 69.7731Z",
    fill: "#E6E1D7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M182.229 68.8199L178.131 66.4349V65.1797L182.229 67.5647V68.8199Z",
    fill: "#E6E1D7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 79.7422L200.245 81.3991V82.6544L197.371 80.9723V79.7422Z",
    fill: "#E6E1D7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M195.697 80.0175L191.949 77.8334V76.5781L195.697 78.7622V80.0175Z",
    fill: "#E6E1D7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M190.275 76.8524L180.105 70.9528V69.7227L190.275 75.6223V76.8524Z",
    fill: "#E6E1D7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M194.173 81.2461L200.245 84.7859V86.0411L194.173 82.5013V81.2461Z",
    fill: "#E6E1D7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M188.751 78.1094L192.499 80.2935V81.5487L188.751 79.3646V78.1094Z",
    fill: "#E6E1D7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M187.076 77.1546V78.3848L183.903 76.5521V75.2969L187.076 77.1546Z",
    fill: "#E6E1D7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M178.131 71.957L182.229 74.342V75.5721L178.131 73.2123V71.957Z",
    fill: "#E6E1D7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 86.4961L200.245 88.1781V89.4083L197.371 87.7513V86.4961Z",
    fill: "#E6E1D7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M195.697 86.7697L191.949 84.6107V83.3555L195.697 85.5396V86.7697Z",
    fill: "#E6E1D7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M180.105 77.7318V76.4766L190.275 82.3762V83.6315L180.105 77.7318Z",
    fill: "#E6E1D7"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6033_37455)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M183.365 211.398H202.257L220.194 221.753L205.046 230.505H182.625L183.365 211.398Z",
    fill: "#7F647E"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M136.52 202.602L151.606 210.583L125.764 225.515L111.31 217.163L136.52 202.602Z",
    fill: "#F7F5ED"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M176.831 217.164L191.917 225.146L174.551 235.162L160.097 226.81L176.831 217.164Z",
    fill: "#F7F5ED"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M103.759 183.68L118.845 191.661L78.5339 214.944L64.0797 206.593L103.759 183.68Z",
    fill: "#E6492F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M116.725 95.387L131.18 87.0508L116.725 78.6992L102.271 87.0508L116.725 95.387Z",
    fill: "#FE8A71"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M116.725 192.678L131.18 184.327V87.0508L116.725 95.387V192.678Z",
    fill: "#FF5638"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M102.271 184.327L116.725 192.678V95.387L102.271 87.0508V184.327Z",
    fill: "#E6492F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M133.106 125.34L147.56 117.004L133.106 108.652L118.652 117.004L133.106 125.34Z",
    fill: "#F7F5ED"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M133.106 202.138L147.56 193.786V117.004L133.106 125.34V202.138Z",
    fill: "#CBC7BC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M118.652 193.786L133.106 202.138V125.34L118.652 117.004V193.786Z",
    fill: "#EEE8DE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M149.486 144.848L163.94 136.512L149.486 128.16L135.032 136.512L149.486 144.848Z",
    fill: "#F7F5ED"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.486 211.599L163.94 203.247V136.512L149.486 144.848V211.599Z",
    fill: "#CBC7BC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M135.032 203.247L149.486 211.599V144.848L135.032 136.512V203.247Z",
    fill: "#EEE8DE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M165.866 171.598L180.321 163.262L165.866 154.91L151.412 163.262L165.866 171.598Z",
    fill: "#F7F5ED"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M165.866 221.045L180.321 212.709V163.262L165.866 171.598V221.045Z",
    fill: "#CBC7BC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M151.412 212.709L165.866 221.045V171.598L151.412 163.262V212.709Z",
    fill: "#EEE8DE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M182.247 209.844L196.701 201.508L182.247 193.156L167.793 201.508L182.247 209.844Z",
    fill: "#F7F5ED"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M182.247 230.507L196.701 222.156V201.508L182.247 209.844V230.507Z",
    fill: "#CBC7BC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M167.793 222.156L182.247 230.507V209.844L167.793 201.508V222.156Z",
    fill: "#EEE8DE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6033_37455",
    x1: 307.639,
    y1: 221.183,
    x2: 298.244,
    y2: 221.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6033_37455",
    x1: 270.083,
    y1: 123.074,
    x2: 270.083,
    y2: 133.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6033_37455",
    x1: 278.504,
    y1: 123.578,
    x2: 278.504,
    y2: 133.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9481FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6033_37455",
    x1: 252.267,
    y1: 97.7192,
    x2: 252.267,
    y2: 111.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9481FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6033_37455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 254,
    fill: "white",
    transform: "matrix(-1 0 0 1 471 53)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6033_37455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.114,
    height: 183.396,
    fill: "white",
    transform: "matrix(-1 0 0 1 220.194 51.7656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogin);
export default __webpack_public_path__ + "static/media/img-login.4a743d84572c04e95232cbcb91704cc7.svg";
export { ForwardRef as ReactComponent };